import { render, staticRenderFns } from "./DependenciesView.vue?vue&type=template&id=c7fafa48&scoped=true"
import script from "./DependenciesView.vue?vue&type=script&lang=js"
export * from "./DependenciesView.vue?vue&type=script&lang=js"
import style0 from "./DependenciesView.vue?vue&type=style&index=0&id=c7fafa48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fafa48",
  null
  
)

export default component.exports